import * as React from "react";
const SvgDirective = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0.5 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 2, height: 2, x: 7, y: 5.5, fill: "currentColor", rx: 1, transform: "rotate(90 7 5.5)" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.8 9v.5A1.8 1.8 0 0 1 9 11.3H3a1.8 1.8 0 0 1-1.8-1.8V9H0v.5a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V9zm0-5H12v-.5a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3V4h1.2v-.5A1.8 1.8 0 0 1 3 1.7h6a1.8 1.8 0 0 1 1.8 1.8z", clipRule: "evenodd" }));
export {
  SvgDirective as default
};
//# sourceMappingURL=directive.js.map
